/* GENERATED FILE */
import type { ReactElement } from "react";
import { Fragment } from "react";
import type { IconVariant } from "../lib";

export default new Map<IconVariant, ReactElement>([
	[
		"duocolor",
		<Fragment key={"duocolor"}>
			<path
				opacity="0.4"
				d="M16 7L16 11"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M6 16H2M6 12H2M6 8H2M12 22V22C14.8003 22 16.2004 22 17.27 21.455C18.2108 20.9757 18.9757 20.2108 19.455 19.27C20 18.2004 20 16.8003 20 14V10C20 7.19974 20 5.79961 19.455 4.73005C18.9757 3.78924 18.2108 3.02433 17.27 2.54497C16.2004 2 14.8003 2 12 2V2C9.19974 2 7.79961 2 6.73005 2.54497C5.78924 3.02433 5.02433 3.78924 4.54497 4.73005C4 5.79961 4 7.19974 4 10V14C4 16.8003 4 18.2004 4.54497 19.27C5.02433 20.2108 5.78924 20.9757 6.73005 21.455C7.79961 22 9.19974 22 12 22Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"duotone",
		<Fragment key={"duotone"}>
			<rect
				opacity="0.12"
				x="4"
				y="2"
				width="16"
				height="20"
				rx="5"
				fill="currentColor"
			/>
			<path
				d="M16 7V11M6 16H2M6 12H2M6 8H2M12 22V22C14.8003 22 16.2004 22 17.27 21.455C18.2108 20.9757 18.9757 20.2108 19.455 19.27C20 18.2004 20 16.8003 20 14V10C20 7.19974 20 5.79961 19.455 4.73005C18.9757 3.78924 18.2108 3.02433 17.27 2.54497C16.2004 2 14.8003 2 12 2V2C9.19974 2 7.79961 2 6.73005 2.54497C5.78924 3.02433 5.02433 3.78924 4.54497 4.73005C4 5.79961 4 7.19974 4 10V14C4 16.8003 4 18.2004 4.54497 19.27C5.02433 20.2108 5.78924 20.9757 6.73005 21.455C7.79961 22 9.19974 22 12 22Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"filled",
		<Fragment key={"filled"}>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M3.75 14.5C3.47386 14.5 3.25 14.2761 3.25 14C3.25 13.7239 3.47386 13.5 3.75 13.5H5C5.82843 13.5 6.5 12.8284 6.5 12C6.5 11.1716 5.82843 10.5 5 10.5H3.75C3.47386 10.5 3.25 10.2761 3.25 10C3.25 9.72386 3.47386 9.5 3.75 9.5H5C5.82843 9.5 6.5 8.82843 6.5 8C6.5 7.17157 5.82843 6.5 5 6.5H3.25C3.25 3.60051 5.6005 1.25 8.5 1.25H12C14.5612 1.25 15.8417 1.25 16.8635 1.63456C18.4806 2.24319 19.7568 3.51941 20.3654 5.1365C20.75 6.15826 20.75 7.43884 20.75 10V14C20.75 16.5612 20.75 17.8417 20.3654 18.8635C19.7568 20.4806 18.4806 21.7568 16.8635 22.3654C15.8417 22.75 14.5612 22.75 12 22.75H8.5C5.60051 22.75 3.25 20.3995 3.25 17.5H5C5.82843 17.5 6.5 16.8284 6.5 16C6.5 15.1716 5.82843 14.5 5 14.5H3.75ZM16 6.25C16.4142 6.25 16.75 6.58579 16.75 7V11C16.75 11.4142 16.4142 11.75 16 11.75C15.5858 11.75 15.25 11.4142 15.25 11V7C15.25 6.58579 15.5858 6.25 16 6.25Z"
				fill="currentColor"
			/>
			<path
				d="M2 7.25C1.58579 7.25 1.25 7.58579 1.25 8C1.25 8.41421 1.58579 8.75 2 8.75H5C5.41421 8.75 5.75 8.41421 5.75 8C5.75 7.58579 5.41421 7.25 5 7.25H2Z"
				fill="currentColor"
			/>
			<path
				d="M2 11.25C1.58579 11.25 1.25 11.5858 1.25 12C1.25 12.4142 1.58579 12.75 2 12.75H5C5.41421 12.75 5.75 12.4142 5.75 12C5.75 11.5858 5.41421 11.25 5 11.25H2Z"
				fill="currentColor"
			/>
			<path
				d="M2 15.25C1.58579 15.25 1.25 15.5858 1.25 16C1.25 16.4142 1.58579 16.75 2 16.75H5C5.41421 16.75 5.75 16.4142 5.75 16C5.75 15.5858 5.41421 15.25 5 15.25H2Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
	[
		"gestalt",
		<Fragment key={"gestalt"}>
			<path
				d="M16 7V11M6 16H4M2 16H4M6 12H4M2 12H4M6 8H4M2 8H4M4 16V14M4 14V12M4 14C4 16.8003 4 18.2004 4.54497 19.27C5.02433 20.2108 5.78924 20.9757 6.73005 21.455C7.79961 22 9.19974 22 12 22C14.8003 22 16.2004 22 17.27 21.455C18.2108 20.9757 18.9757 20.2108 19.455 19.27C20 18.2004 20 16.8003 20 14V10C20 7.19974 20 5.79961 19.455 4.73005C18.9757 3.78924 18.2108 3.02433 17.27 2.54497C16.2004 2 14.8003 2 12 2C9.19974 2 7.79961 2 6.73005 2.54497C5.78924 3.02433 5.02433 3.78924 4.54497 4.73005M4 12V8"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"line",
		<Fragment key={"line"}>
			<path
				d="M16 7V11M6 16H2M6 12H2M6 8H2M12 22V22C14.8003 22 16.2004 22 17.27 21.455C18.2108 20.9757 18.9757 20.2108 19.455 19.27C20 18.2004 20 16.8003 20 14V10C20 7.19974 20 5.79961 19.455 4.73005C18.9757 3.78924 18.2108 3.02433 17.27 2.54497C16.2004 2 14.8003 2 12 2V2C9.19974 2 7.79961 2 6.73005 2.54497C5.78924 3.02433 5.02433 3.78924 4.54497 4.73005C4 5.79961 4 7.19974 4 10V14C4 16.8003 4 18.2004 4.54497 19.27C5.02433 20.2108 5.78924 20.9757 6.73005 21.455C7.79961 22 9.19974 22 12 22Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"mono",
		<Fragment key={"mono"}>
			<path
				opacity="0.32"
				d="M12 1.25C9.43884 1.25 8.15826 1.25 7.1365 1.63456C5.51941 2.24319 4.24319 3.51941 3.63456 5.1365C3.25 6.15826 3.25 7.43884 3.25 10V14C3.25 16.5612 3.25 17.8417 3.63456 18.8635C4.24319 20.4806 5.51941 21.7568 7.1365 22.3654C8.15826 22.75 9.43884 22.75 12 22.75C14.5612 22.75 15.8417 22.75 16.8635 22.3654C18.4806 21.7568 19.7568 20.4806 20.3654 18.8635C20.75 17.8417 20.75 16.5612 20.75 14V10C20.75 7.43884 20.75 6.15826 20.3654 5.1365C19.7568 3.51941 18.4806 2.24319 16.8635 1.63456C15.8417 1.25 14.5612 1.25 12 1.25Z"
				fill="currentColor"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M16 6.25C16.4142 6.25 16.75 6.58579 16.75 7V11C16.75 11.4142 16.4142 11.75 16 11.75C15.5858 11.75 15.25 11.4142 15.25 11V7C15.25 6.58579 15.5858 6.25 16 6.25ZM1.25 8C1.25 7.58579 1.58579 7.25 2 7.25H6C6.41421 7.25 6.75 7.58579 6.75 8C6.75 8.41421 6.41421 8.75 6 8.75H2C1.58579 8.75 1.25 8.41421 1.25 8ZM1.25 12C1.25 11.5858 1.58579 11.25 2 11.25H6C6.41421 11.25 6.75 11.5858 6.75 12C6.75 12.4142 6.41421 12.75 6 12.75H2C1.58579 12.75 1.25 12.4142 1.25 12ZM1.25 16C1.25 15.5858 1.58579 15.25 2 15.25H6C6.41421 15.25 6.75 15.5858 6.75 16C6.75 16.4142 6.41421 16.75 6 16.75H2C1.58579 16.75 1.25 16.4142 1.25 16Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
]);
